// mutations
const SET_RESULTINSTITUTION = (state, payload) => {
  state.list_institution = payload;
};
const SET_INPUTMASTERINSTITUTION = (state, payload) => {
  state.tempMasterInstitution = payload;
};
const SET_IDMASTERINSTITUTION = (state, payload) => {
  state.idMasterInstitution = payload;
};
const SET_RESULTEDUCATIONLEVEL = (state, payload) => {
  state.res_eduLevel = payload;
};
export default {
  SET_RESULTINSTITUTION,
  SET_INPUTMASTERINSTITUTION,
  SET_IDMASTERINSTITUTION,
  SET_RESULTEDUCATIONLEVEL
};
